export const CONFERENCE_HELD_ID_PREFIX = 'conference-held-';